<template>
    <b-modal id="passwordModal" title="비밀번호 변경" hide-footer v-if="show">
      <b-form @submit="onSubmit" @reset="onReset">
        <input type="hidden"
        v-model="form.mailuser_id">
        <b-form-group label="선택된 사용자" label-for="password">
          <span v-if="user">{{user.name}} (그룹웨어: {{user.gw_name}})</span>
        </b-form-group>
        <b-form-group label="비밀번호" label-for="password">
          <b-form-input id="changePassword" type="password" v-model="form.password" required placeholder="비밀번호를 입력하세요"></b-form-input>
        </b-form-group>
        <b-form-group label="비밀번호 확인" label-for="passwordRepeat">
          <b-form-input id="changePasswordRepeat" type="password" v-model="form.passwordRepeat" required placeholder="비밀번호를 한 번 더 입력하세요"></b-form-input>
          <div class="invalid-feedback">
            입력하신 비밀번호가 다릅니다
          </div>
        </b-form-group>
        <b-button type="submit" variant="primary">저장</b-button>
      </b-form>
    </b-modal>
</template>

<script>
export default {
  props: {
    user: Object
  },
  data() {
    return {
      form: {
        password: '',
        passwordRepeat: ''
      },
      show: true
    };
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault();
      if (this.form.password != this.form.passwordRepeat) {
        alert('입력하신 비밀번호가 다릅니다. 비밀번호를 확인해주세요.')
      } else {
        this.$http.patch('crew/' + this.user.mailuser_id + '/password/', this.form)
        .then(response => {
          window.console.log(response)
          alert('비밀번호를 변경했습니다. 비밀번호: ' + this.form.password)
          this.form = {}
          this.show = false
          this.$nextTick(() => { this.show = true })
        })
        .catch(error => {
          window.console.log(error)
          alert('오류가 발생했습니다.')
        })
      }      
    },
    onReset (evt) {
      evt.preventDefault();
      this.form = {}
      this.show = false
      this.$nextTick(() => { this.show = true })
    }
  }
}
</script>
